import CloseIcon from "@/common/images/icons/cross.svg?react";
import { ChangeEvent, MouseEvent, useCallback, useEffect, useState } from "react";
import SecondaryButton from "components/core/SecondaryButton";
import { ITag } from "components/tags/types";

import classes from "./AddingTag.module.css";
import { apiTags } from "@/common/services";
import { useFetch } from "@/common/hooks/useFetch";

interface IProps {
  onAdded: (tag: string) => (event: MouseEvent) => void;
  onClose: () => void;
  addedTags: string[];
}

export const AddingTag = ({ onAdded, onClose, addedTags }: IProps) => {
  const [currentValue, setCurrentValue] = useState("");
  const [filteredTags, setFilteredTags] = useState<ITag[]>([]);

  const fetchTags = useCallback(() => apiTags.getTags(), []);
  const { data: tagsData } = useFetch(fetchTags);

  useEffect(() => {
    if (currentValue.length > 0 && tagsData?.tags) {
      const newTags = tagsData.tags.filter((el: ITag) => {
        if (addedTags.indexOf(el.name) !== -1) {
          return false;
        }

        return el.name.toLowerCase().includes(currentValue.toLowerCase());
      });
      setFilteredTags(newTags.slice(0, 3));
    } else {
      setFilteredTags([]);
    }
  }, [currentValue, tagsData, addedTags]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(event.currentTarget.value);
  };

  return (
    <SecondaryButton variant="default" type="button">
      <div className={classes.wrapper}>
        <div className={classes.btn}>
          <input className={classes.input} placeholder="Search tags." type="text" value={currentValue} onChange={handleChange} />
          <div className={classes.remove} onClick={onClose}>
            <CloseIcon className={classes.removeIcon} />
          </div>
        </div>
        {filteredTags.length > 0 && (
          <ul className={classes.dropdown}>
            {
              filteredTags.map((tag: ITag, index: number) => {
                return <li
                  key={index}
                  className={classes.dropdownItem}
                  onClick={onAdded(tag.name)}
                >
                  {tag.name}
                </li>;
              })
            }
          </ul>
        )}
      </div>
    </SecondaryButton>
  );
};
